/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Sliders(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M135.99707,65.376V39.99988a8,8,0,0,0-16,0V65.376a23.995,23.995,0,0,0,0,45.2478v105.3761a8,8,0,0,0,16,0V110.62378a23.995,23.995,0,0,0,0-45.2478Z" />
        <Path d="M223.99707,167.99988a24.03744,24.03744,0,0,0-16-22.6239l.001-105.3761a8,8,0,1,0-16,0l-.001,105.3761a23.995,23.995,0,0,0,0,45.2478l.001,25.3761a8,8,0,0,0,16,0l-.001-25.37622A24.03728,24.03728,0,0,0,223.99707,167.99988Z" />
        <Path d="M63.99707,113.376l-.00049-73.3761a8,8,0,0,0-16,0l.00049,73.3761a23.995,23.995,0,0,0,0,45.2478l-.00049,57.3761a8,8,0,1,0,16,0l.00049-57.3761a23.995,23.995,0,0,0,0-45.2478Z" />
      </G>
    </Svg>
  );
}

export default Sliders;
